<template>
    <BreadCrumb PageTitle="Ajouter un emprunt" />
    <AddEmprunt/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddEmprunt from "@/components/Emprunt/AddEmprunt.vue";
   
    export default defineComponent({
      name: "AddEmpruntPage",
      components: {
        BreadCrumb,
        AddEmprunt,
      },
    });
  </script>